import { gql } from "@apollo/client";

export const CREATE_STARTUP = gql`
  mutation createStartup(
    $NAM: String
    $HDQ: String
    $ECO: ID
    $IND: ID
    $INT: ID
    $LEG: ID
    $MOD: ID
    $EMP: Int
    $FDN: ID
    $WDW: ID
    $MCN: ID
    $MAN: ID
    $FOU: Int
    $MAIL_PERSONAL: String
    $MAIL_COMPANY: String
    $website: String
  ) {
    createStartup(
      data: {
        NAM: $NAM
        HDQ: $HDQ
        ECO: $ECO
        IND: $IND
        INT: $INT
        LEG: $LEG
        MOD: $MOD
        EMP: $EMP
        FOU: $FOU
        WDW: $WDW
        MCN: $MCN
        MAN: $MAN
        FDN: $FDN
        MAIL_PERSONAL: $MAIL_PERSONAL
        MAIL_COMPANY: $MAIL_COMPANY
        website: $website
      }
    ) {
      data {
        id
        attributes {
          NAM
        }
      }
    }
  }
`;

export const CREATE_PARTICIPANT_PROFILE = gql`
  mutation createParticipantProfile(
    $GDR: ID
    $AGE: Int
    $EDC: ID
    $ABC: ID
    $EOE: Int
    $ROL: ID
    $AHS: ID
    $FRM: ID
    $FAG: ID
    $FAGL: String
    $WFW: String
    $startupid: ID
  ) {
    createParticipantProfile(
      data: {
        GDR: $GDR
        AGE: $AGE
        EDC: $EDC
        ABC: $ABC
        EOE: $EOE
        ROL: $ROL
        AHS: $AHS
        FRM: $FRM
        FAG: $FAG
        FAGL: $FAGL
        WFW: $WFW
        startupid: $startupid
        type: "founder"
      }
    ) {
      data {
        id
      }
    }
  }
`;
export const CREATE_USER_PROFILE = gql`
  mutation createParticipantProfile(
    $GDR: ID
    $AGE: Int
    $EDC: ID
    $ABC: ID
    $EOE: Int
    $ROL: ID
    $startupid: ID
  ) {
    createParticipantProfile(
      data: {
        GDR: $GDR
        AGE: $AGE
        EDC: $EDC
        ABC: $ABC
        EOE: $EOE
        ROL: $ROL
        startupid: $startupid
        type: "user"
      }
    ) {
      data {
        id
      }
    }
  }
`;
export const CREATE_TALENT_SCORE = gql`
  mutation createTalentScore(
    $ENG_1: ID
    $ENG_2: ID
    $ENG_3: ID
    $ENG_4: ID
    $ENG_5: ID
    $ENG_6: ID
    $ENG_7: ID
    $ENG_8: ID
    $D_O1: ID
    $D_O2: ID
    $D_O3: ID
    $D_P1: ID
    $D_P2: ID
    $D_P3: ID
    $DAF_1: ID
    $DAF_2: ID
    $DAF_3: ID
    $BED1: ID
    $BED2: ID
    $startupid: ID
  ) {
    createTalentScore(
      data: {
        ENG_1: $ENG_1
        ENG_2: $ENG_2
        ENG_3: $ENG_3
        ENG_4: $ENG_4
        ENG_5: $ENG_5
        ENG_6: $ENG_6
        ENG_7: $ENG_7
        ENG_8: $ENG_8
        D_O1: $D_O1
        D_O2: $D_O2
        D_O3: $D_O3
        D_P1: $D_P1
        D_P2: $D_P2
        D_P3: $D_P3
        DAF_1: $DAF_1
        DAF_2: $DAF_2
        DAF_3: $DAF_3
        BED1: $BED1
        BED2: $BED2
        startupid: $startupid
      }
    ) {
      data {
        id
      }
    }
  }
`;
export const CREATE_HALF_YEAR = gql`
  mutation createStartupdataHalbjahr(
    $EMP: Int
    $INT: ID
    $VAC: ID
    $VAC_1: Int
    $NHC: ID
    $BTW: Int
    $CUS_B: Int
    $CUS_E: Int
    $CUS_N: Int
    $DAF_1: ID
    $DAF_2: ID
    $DAF_3: ID
    $BED1: ID
    $BED2: ID
    $LNK_R: ID
    $LNK_N: ID
    $LNK_I: ID
    $IEV_R: ID
    $IEV_N: ID
    $IEV_I: ID
    $IEV_C: ID
    $NTW_US: [ID]
    $NTW_UT: String
    $NTW_M: String
    $CON: ID
    $ST_S: [ID]
    $FSCS: [ID]
    $VC_3: ID
    $VC_5: ID
    $VC_6: ID
    $VC_8: ID
    $MME: ID
    $RVN: ID
    $RVN_1: ID
    $BST_C: ID
    $BST_F: ID
    $WNF: ID
    $WNFT: String
    $DOE: ID
    $DOET: String
    $DSE: ID
    $DSET: String
    $NRI: ID
    $NRIT: String
    $startupid: ID
  ) {
    createStartupdataHalbjahr(
      data: {
        EMP: $EMP
        INT: $INT
        VAC: $VAC
        VAC_1: $VAC_1
        NHC: $NHC
        BTW: $BTW
        CUS_B: $CUS_B
        CUS_E: $CUS_E
        CUS_N: $CUS_N
        DAF_1: $DAF_1
        DAF_2: $DAF_2
        DAF_3: $DAF_3
        BED1: $BED1
        BED2: $BED2
        LNK_R: $LNK_R
        LNK_N: $LNK_N
        LNK_I: $LNK_I
        IEV_R: $IEV_R
        IEV_N: $IEV_N
        IEV_I: $IEV_I
        IEV_C: $IEV_C
        NTW_US: $NTW_US
        NTW_UT: $NTW_UT
        NTW_M: $NTW_M
        CON: $CON
        ST_S: $ST_S
        FSCS: $FSCS
        VC_3: $VC_3
        VC_5: $VC_5
        VC_6: $VC_6
        VC_8: $VC_8
        MME: $MME
        RVN: $RVN
        RVN_1: $RVN_1
        BST_c: $BST_C
        BST_f: $BST_F
        WNF: $WNF
        WNFT: $WNFT
        DOE: $DOE
        DOET: $DOET
        DSE: $DSE
        DSET: $DSET
        NRI: $NRI
        NRIT: $NRIT
        startupid: $startupid
      }
    ) {
      data {
        id
      }
    }
  }
`;

export const CREATE_YEAR = gql`
  mutation createStartupdataJahr(
    $EMP: Int
    $INT: ID
    $VAC: ID
    $VAC_1: Int
    $NHC: ID
    $CUS_B: Int
    $CUS_E: Int
    $CUS_N: Int
    $DAF_1: ID
    $DAF_2: ID
    $DAF_3: ID
    $BED1: ID
    $BED2: ID
    $LNK_R: ID
    $LNK_N: ID
    $LNK_I: ID
    $IEV_R: ID
    $IEV_N: ID
    $IEV_I: ID
    $COP: ID
    $COP_R: ID
    $NTW_U: ID
    $NTW_S: ID
    $NTW_B: ID
    $NTW_M: String
    $CON: ID
    $ISC: ID
    $EXP: ID
    $ST_F: ID
    $FSC: ID
    $VC_1: ID
    $VC_2: ID
    $VC_3: ID
    $VC_4: ID
    $VC_5: ID
    $VC_6: ID
    $MME: ID
    $RVN: ID
    $RVN_1: ID
    $PFT: ID
    $PFT_1: ID
    $PFT_2: Int
    $BST_C: ID
    $BST_F: ID
    $startupid: ID
  ) {
    createStartupdataJahr(
      data: {
        EMP: $EMP
        INT: $INT
        VAC: $VAC
        VAC_1: $VAC_1
        NHC: $NHC
        CUS_B: $CUS_B
        CUS_E: $CUS_E
        CUS_N: $CUS_N
        DAF_1: $DAF_1
        DAF_2: $DAF_2
        DAF_3: $DAF_3
        BED1: $BED1
        BED2: $BED2
        LNK_R: $LNK_R
        LNK_N: $LNK_N
        LNK_I: $LNK_I
        IEV_R: $IEV_R
        IEV_N: $IEV_N
        IEV_I: $IEV_I
        COP: $COP
        COP_R: $COP_R
        NTW_U: $NTW_U
        NTW_S: $NTW_S
        NTW_B: $NTW_B
        NTW_M: $NTW_M
        CON: $CON
        ISC: $ISC
        EXP: $EXP
        ST_F: $ST_F
        FSC: $FSC
        VC_1: $VC_1
        VC_2: $VC_2
        VC_3: $VC_3
        VC_4: $VC_4
        VC_5: $VC_5
        VC_6: $VC_6
        MME: $MME
        RVN: $RVN
        RVN_1: $RVN_1
        PFT: $PFT
        PFT_1: $PFT_1
        PFT_2: $PFT_2
        BST_c: $BST_C
        BST_f: $BST_F
        startupid: $startupid
      }
    ) {
      data {
        id
      }
    }
  }
`;
